module.exports = __webpack_public_path__ + "img/Icon_view_default.6b357180.svg";